<script setup>
import { secondaryDividerBorder } from '@/Common/util/tailwind/colorConstants'
import { CpuChipIcon } from '@heroicons/vue/24/outline'
import { computed, ref, useId } from 'vue'
import AgentMarkdown from '../AgentMarkdown.vue'
import { reasoningDisplayFromText } from '../BidBoostLangGraphTransport'
import ActivityDisclosure from './ActivityDisclosure.vue'
import { reasoningActivityLabel } from './activityLabels'

const props = defineProps({
  part: { type: Object, required: true },
  status: { type: String, default: 'complete' },
})

const open = ref(false)
const hasOpened = ref(false)
const contentId = useId()
function toggleOpen() {
  hasOpened.value = true
  open.value = !open.value
}

const reasoning = computed(() => reasoningDisplayFromText(props.part.text))
const running = computed(
  () => props.status === 'running' && props.part.state === 'streaming'
)
const label = computed(() => reasoningActivityLabel(props.part, props.status))
</script>

<template>
  <div class="min-w-0" data-testid="activity-reasoning">
    <ActivityDisclosure
      :open="open"
      :running="running"
      :label="label"
      :icon="CpuChipIcon"
      :aria-controls="hasOpened ? contentId : undefined"
      data-testid="activity-reasoning-disclosure"
      @toggle="toggleOpen"
    />
    <div
      v-if="hasOpened"
      v-show="open"
      :id="contentId"
      class="ml-2 mt-1 min-w-0 border-l pl-3"
      :class="secondaryDividerBorder"
      data-testid="activity-reasoning-content"
    >
      <AgentMarkdown
        v-if="reasoning.text"
        :content="reasoning.text"
        variant="reasoning"
      />
    </div>
  </div>
</template>
